import { useMemo } from "react"

import useAllQuestsMultiSelectStore from "./useAllQuestsMultiSelectStore"
import { useAllQuestsSearchStore } from "./useAllQuestsSearchStore"
import {
  useAllQuestsQuery,
  useFamilyQuery,
} from "../../../../networking/queries"
import { FamilyQuerySelect, UserSelectFilterType } from "../../../../types"
import useQuestBoardStore from "../../useQuestBoardStore"

const useQuestBoardDndFilters = () => {
  const { data, isLoading } = useAllQuestsQuery()
  const { data: children } = useFamilyQuery(FamilyQuerySelect.CHILDREN)
  const childIds = children?.map((child) => child.user.id)
  const { selectedFilterType, selectedUserId } = useQuestBoardStore()
  const { selectedQuestSeriesIds } = useAllQuestsMultiSelectStore()
  const { searchQuery } = useAllQuestsSearchStore()

  const filteredQuests = useMemo(() => {
    return (
      data?.filter((quest) => {
        // Remove self-initiated quests

        if (quest.assigner_profile === null) {
          return false
        }
        // Filter quests by select option
        if (selectedFilterType === UserSelectFilterType.ALL_USERS) {
          return true
        }
        if (selectedFilterType === UserSelectFilterType.ALL_KIDS) {
          return childIds?.includes(quest.user_id)
        }
        // Filter quests by user
        if (selectedUserId && quest.user_id !== selectedUserId) {
          return false
        }
        return true
      }) || []
    )
  }, [data, selectedFilterType, selectedUserId, childIds])

  const searchFilteredQuests = useMemo(() => {
    return filteredQuests.filter((quest) => {
      return (
        quest.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
        selectedQuestSeriesIds.includes(quest.id)
      )
    })
  }, [filteredQuests, searchQuery, selectedQuestSeriesIds])

  const activeQuests = useMemo(() => {
    return searchFilteredQuests.filter((quest) => quest.is_active)
  }, [searchFilteredQuests])

  const inactiveQuests = useMemo(() => {
    const allInactiveQuests = searchFilteredQuests.filter(
      (quest) => !quest.is_active
    )

    // Deduplicate inactive quests by group_id (same logic as active quests)
    const seenQuestGroupIds = new Set()
    const deduplicatedInactiveQuests = allInactiveQuests.filter((quest) => {
      if (quest.quest_group_id === null) return true
      if (!seenQuestGroupIds.has(quest.quest_group_id)) {
        seenQuestGroupIds.add(quest.quest_group_id)
        return true
      }
      return false
    })

    return deduplicatedInactiveQuests
  }, [searchFilteredQuests])

  return {
    activeQuests,
    inactiveQuests,
    isLoading,
  }
}

export default useQuestBoardDndFilters
